<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Work Orders to Assign"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Assign work orders to technicians."
      @on-submit="createAssignWorkOrdersImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Work Orders to Assign Template.xlsx"
              :file-provider="$importsAPI.getAssignWorkOrdersTemplate"
            />
          </b-col>
        </b-row>
      </template>
      >
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'AssignWorkOrdersImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'assign-work-orders-imports-add-modal',
    };
  },
  methods: {
    createAssignWorkOrdersImport(data, handleCreate) {
      handleCreate(this.$importsAPI.assignWorkOrdersCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
